<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Tipe Pelunasan</h5>
            </template>

            <b-row class="mb-3">
                <b-col cols="12" md="6">
                    <b-form-group label="No. Faktur">
                        <b-form-input
                            v-model="filters.noFaktur"
                            id="filterInput"
                            type="search"
                            placeholder="Masukkan No. Faktur"
                            @keyup.enter="onSearch()"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group label="Status">
                        <b-form-select
                            v-model="filters.status"
                            id="filterStatus"
                            name="status"
                            :options="optionsStatus"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6" v-if="optionsCabang.length > 2">
                    <b-form-group label="Cabang">
                        <multiselect
                            name="dariCabang"
                            v-model="filters.cabang" 
                            :options="optionsCabang" 
                            :internal-search="true"
                            :allow-empty="false"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="name"
                            placeholder="Cabang"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="12" lg="6">
                    <b-form-group label="Tanggal">
                        <div class="d-flex" :class="isMobile ? 'flex-wrap' : ''">
                            <b-form-input
                                v-model="filters.startDate"
                                name="filterFromDate"
                                id="filterDate"
                                type="date"
                                class="flex-fill"
                            ></b-form-input>
                            <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                            <b-form-input 
                                v-model="filters.endDate"
                                name="filterToDate"
                                type="date"
                                class="flex-fill"
                            ></b-form-input>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="12">
                    <div class="d-flex search-input-wrapper">
                        <b-button variant="pgiBtn" :disabled="isBusy" class="mr-2" @click="onSearch()"> 
                        Search
                        </b-button>
                        <b-button variant="pgiBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                    </div>
                </b-col>
            </b-row>

            <div class="detail-data-wrapper">
                <b-table bordered hover show-empty 
                    :busy="isBusy" 
                    :items="data"
                    :no-local-sorting="false" 
                    :fields="isMobile ? fieldsMobile : fieldsDesktop"
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data perubahan tipe pelunasan.
                    </template>
                    <template v-if="isMobile" v-slot:cell(detail)="row">
                        <small class="d-block mb-1">No. Kwitansi: {{ row.item.noKwitansi }}</small>
                        <small class="d-block mb-1">No. Faktur: {{ row.item.noFaktur }}</small>
                        <small class="d-block mb-1">Metode Pembayaran: {{ row.item.tunai ? 'Tunai' : 'Transfer' }}</small>
                        <small class="d-block mb-1">
                            Status:
                            <b-badge variant="warning" v-if="row.item.status == 0">Pending</b-badge>
                            <b-badge variant="success" v-else-if="row.item.status == 1">Disetujui</b-badge>
                            <b-badge variant="danger" v-else-if="row.item.status == 2">Ditolak</b-badge>
                            <b-badge v-else>{{ row.item.status }}</b-badge>
                        </small>
                        <small class="d-block mb-1">Cabang: {{ row.item.cabangName }}</small>
                        <small class="d-block mb-0">Tanggal: {{$helper.changeDateFormat(row.item.createdAt)}} {{$helper.changeDateFormatGetHour(row.item.createdAt)}}</small>

                        <div class="mt-1">
                            <small class="d-block mb-1">Tipe Pelunasan: </small>
                            <small class="d-block mb-1 text-muted ml-2">{{ handleTextTipePelunasan(row.item.tipePelunasanSebelum) }} (Saat Ini)</small>
                            <div class="wrapper-arrow-tipe-pelunasan">
                                <i class="fa fa-arrow-down text-muted"></i>
                            </div>
                            <small class="d-block mb-1 ml-2">{{ handleTextTipePelunasan(row.item.tipePelunasanSesudah) }} (Pengajuan)</small>
                        </div>
                    </template>
                    <template v-slot:cell(informasiTransaksi)="row">
                        <p class="mb-0">{{row.item.noKwitansi}}</p>
                        <p class="mb-0 smallText text-muted">NF {{row.item.noFaktur}}</p>
                        <p class="mb-0 smallText">
                            {{row.item.tunai ? 'Tunai' : 'Transfer'}}
                        </p>
                    </template>
                    <template v-slot:cell(cabangAndTanggal)="row">
                        <p class="mb-0">{{row.item.cabangName}}</p>
                        <p class="mb-0 smallText text-muted">{{$helper.changeDateFormat(row.item.createdAt)}} {{$helper.changeDateFormatGetHour(row.item.createdAt)}}</p>
                    </template>
                    <template v-slot:cell(tipePelunasan)="row">
                        <p class="mb-0 text-muted">Saat Ini: {{ handleTextTipePelunasan(row.item.tipePelunasanSebelum) }}</p>
                        <div class="wrapper-arrow-tipe-pelunasan">
                            <i class="fa fa-arrow-down text-muted"></i>
                        </div>
                        <p class="mb-0">Pengajuan: {{ handleTextTipePelunasan(row.item.tipePelunasanSesudah) }}</p>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge variant="warning" v-if="row.item.status == 0">Pending</b-badge>
                        <b-badge variant="success" v-else-if="row.item.status == 1">Disetujui</b-badge>
                        <b-badge variant="danger" v-else-if="row.item.status == 2">Ditolak</b-badge>
                        <b-badge v-else>{{ row.item.status }}</b-badge>   
                    </template>
                    <template v-slot:cell(action)="row">
                        <div class="no-wrap" v-if="row.item.status == 0">
                            <b-button v-if="IS_HAVE_PERMISSION_APPROVAL_EDIT_TIPE_PELUNASAN" size="sm" class="mr-2" variant="success" @click="onShowModalApprove(row.item.noFaktur)">
                                <i class="fa fa-check"></i>
                            </b-button>
                            <b-button v-if="IS_HAVE_PERMISSION_REJECT_EDIT_TIPE_PELUNASAN" size="sm" variant="danger" name="danger" @click="onShowModalReject(row.item.noFaktur)">
                                <i class="fa fa-close"></i>
                            </b-button>
                        </div>
                        <div v-else>
                        </div>
                    </template>
                </b-table>

                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="show" @change="onLimitChange" :options="optionsLimit">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </div>
        </b-card>
        
        <ModalConfirm 
            id="modal-approve" 
            title="Konfirmasi Persetujuan Tipe Pelunasan" 
            :isSubmitting="isLoadingApprove"
            desc="Apakah Anda yakin ingin menyetujui perubahan tipe pelunasan ini?" 
            @submit="onApprove"
        />

        <ModalConfirm 
            id="modal-reject" 
            title="Konfirmasi Penolakan Tipe Pelunasan" 
            :isSubmitting="isLoadingReject"
            desc="Apakah Anda yakin ingin menolak perubahan tipe pelunasan ini?" 
            @submit="onReject" 
        />
    </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
    name: 'edit-tipe-pelunasan',
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            data: [],
            fieldsDesktop: [
                { key: "informasiTransaksi", label: "Informasi Transaksi" },
                { key: "cabangAndTanggal", label: "Cabang & Tanggal" },
                { key: "tipePelunasan", label: "Tipe Pelunasan", thClass: 'min-width-200', tdClass: 'min-width-200' },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            fieldsMobile: [
                { key: "detail", label: "Detail" },
                { key: "action", label: "Aksi" },
            ],
            filters: {
                noFaktur: '',
                status: '',
                cabang: null,
                startDate: null,
                endDate: null,
            },
            currentPage: 1,
            show: 10,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            totalViewText: "",
            optionsLimit: CONSTANTS.OPTIONS_LIMIT_PAGINATION,
            optionsStatus: CONSTANTS.OPTIONS_STATUS_EDIT_TIPE_PELUNASAN,
            optionsCabang: [],
            keterangan: '',
            isMobile: false,
            selectedNoFaktur: null,
            isLoadingApprove: false,
            isLoadingReject: false,
        }
    },
    methods: {
        async init() {
            this.initStatus = 0
            try {
                this.getCabang()
                await this.getItems()
                this.initStatus = 1
            } catch (error) {
                this.$helper.parseError(this, error)
                this.initStatus = -1
            }
        },
        getItems(page = 1) {
            this.isBusy = true
            this.data = []
            this.currentPage = isNaN(page) ? 1 : page

            const params = {
                page: this.currentPage - 1,
                size: this.perPage,
            }

            if (!this.$helper.isNullOrEmpty(this.filters.noFaktur)) {
                params.noFaktur = this.filters.noFaktur;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.status) || this.filters.status === 0) {
                params.status = this.filters.status;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.startDate)) {
                params.startDate = this.filters.startDate;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.endDate)) {
                params.endDate = this.filters.endDate;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.cabang)) {
                params.cabangName = this.filters.cabang.name;
            }

            if (this.filters.cabang && this.filters.cabang.id === null) {
                delete params.cabangName
            }

            return this.$axios.get("gadai-evidence/get-tipe-pelunasan", {
                params,
            }).then(res => {

                this.data = res.data.content
                this.totalRows = res.data.totalElements

                let pg = this.currentPage - 1

                let prev = pg * this.show + 1
                let limit = pg * this.show + this.show
                if (limit > this.totalRows) limit = this.totalRows

                this.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.totalRows + " entri"
            }).catch(error => {
                this.$helper.parseError(this, error)
                throw error
            })
            .finally(() => {
                this.isBusy = false
            })
        },
        getCabang() {
            const getCabang = localStorage.getItem("cabang")
            const cabang = JSON.parse(getCabang);

            const mappingName = cabang.map(item => ({
                ...item,
                name: item.name.replace(/^\(\d+\)\s*/, "")
            }));

            this.optionsCabang = [
                { id: null, name: "Semua Cabang" },
                ...mappingName
            ]
        },
        onShowModalApprove(id) {
            this.selectedNoFaktur = id;
            this.$bvModal.show("modal-approve")
        },
        onShowModalReject(id) {
            this.selectedNoFaktur = id;
            this.$bvModal.show("modal-reject")
        },
        onApprove() {
            const id = this.selectedNoFaktur;
            this.isLoadingApprove = true;
            this.$axios.put(`gadai-evidence/update-approval-status/${id}?status=1`)
                .then((response) => {
                    this.$helper.toastSucc(this, response.data.name)
                    this.getItems(this.currentPage)
                    this.$bvModal.hide("modal-approve")
                })
                .catch((error) => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isLoadingApprove = false;
                })
        },
        onReject() {
            const id = this.selectedNoFaktur;
            this.isLoadingReject = true;
            this.$axios.put(`gadai-evidence/update-approval-status/${id}?status=2`)
                .then((response) => {
                    this.$helper.toastSucc(this, response.data.name)
                    this.getItems(this.currentPage)
                    this.$bvModal.hide("modal-reject")
                })
                .catch((error) => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isLoadingReject = false;
                })
        },
        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },
        onPageChange(newPage) {
            this.getItems(newPage)
        },
        onSearch() {
            this.getItems()
        },
        onReset() {
            this.filters = {
                noFaktur: '',
                status: '',
                cabang: null,
                startDate: null,
                endDate: null,
            }

            this.getItems()
        },
        handleResize() {
            this.isMobile = window.innerWidth <= 576;
        },
        handleTextTipePelunasan(tipe) {
            const option = CONSTANTS.OPTIONS_TIPE_PELUNASAN.find(o => o.value === tipe);
            return option ? option.text : "";
        },
    },
    computed: {
        IS_HAVE_PERMISSION_APPROVAL_EDIT_TIPE_PELUNASAN() {
            const permissionApprovalEditTipePelunasan = CONSTANTS.PERMISSION.EDIT_TIPE_PELUNASAN.APPROVAL;
            return this.$helper.hasPermissionMenuChildren(permissionApprovalEditTipePelunasan)
        },
        IS_HAVE_PERMISSION_REJECT_EDIT_TIPE_PELUNASAN() {
            const permissionRejectEditTipePelunasan = CONSTANTS.PERMISSION.EDIT_TIPE_PELUNASAN.REJECT;
            return this.$helper.hasPermissionMenuChildren(permissionRejectEditTipePelunasan)
        }
    },
    created() {
        this.init();
    },
    mounted() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    }
}
</script>

<style>
.wrapper-arrow-tipe-pelunasan {
    margin-left: 25%;
}
</style>